export const getProjectModalOpened = (state) => state.projectModal.projectModalOpened
export const getProjectModalInfo = (state) => state.projectModal.projectModalInfo